import { MdOutlineWarehouse } from 'react-icons/md';

import ContractSection from './ContractSection';
import { nameAndPriceColumns } from './helper';

const Warehousing = ({ services = [] }) => {
  const warehousingServices = services.filter((service) => service.serviceType === 'warehousing');

  if (!warehousingServices.length) return null;

  return (
    <ContractSection
      icon={MdOutlineWarehouse}
      title="Хадгалалтын төлбөр"
      description="Агуулахад бараа хадгалуулах — байршуулах нэгжийн төрөл тус бүрийн төлбөр."
      columns={nameAndPriceColumns}
      dataSource={warehousingServices}
    />
  );
};

export default Warehousing;
